// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__3KDAy","error-label":"LoginForm_error-label__2dcSb"};